<template>
    <b-modal ref="modal" @hidden="cancelModal" centered :visible="true">
        <template>
            <div class="selector layout v">
                <header class="layout h center">
                    <h1 class="flex">Select demo track</h1>
                    <a href="#" @click.prevent="cancelModal">{{ Translations.buttons.cancel }}</a>
                    <a href="#" @click.prevent="confirmModal">Done</a>
                </header>

                <div class="search">
                    <input type="text" autofocus class="fit" ref="inputSearch" maxlength="100" placeholder="Search tracks" v-model="searchData.searchTerm" @keypress="searchDelay(150)" />
                </div>

                <div class="results flex scrollable">
                    <WaitingBlock v-if="modalState.isLoadingTracks"></WaitingBlock>
                    <ul class="select-list" v-else-if="searchResult && searchResult.length">
                        <li v-for="track in searchResult"
                            :key="track.uid"
                            :class="['layout', 'h', 'center', {'selected' : isSelected(track.uid)}]"
                            @click.prevent="toggleTrack(track)">
                            <div class="check"><i class="fa fa-check"></i></div>
                            <span class="name">{{track.title}}</span>
                        </li>
                    </ul>
                    <div v-else class="no-result-container">
                        <div class="no-record">No track matching your search criteria</div>
                    </div>
                </div>

                <footer v-if="selected && selected.title">
                    <div class="selection-container">
                        <div class="title">Selected track:</div>
                        <section class="layout h wrap">
                            <div class="badge selected">
                                <span class="name">{{selected.title}}</span>
                                <a href="#" class="remove" @click.prevent="toggleTrack(selected)">×</a>
                            </div>
                        </section>
                    </div>
                </footer>

            </div>

        </template>

    </b-modal>

</template>

<script>
    import Vue from 'vue'
    import Translations from '@/store/translations';
    import { mapState } from 'vuex';
    import WaitingBlock from '@/components/common/WaitingBlock.vue';
    //import Modal from '@/components/common/FormModal.vue';
    import Bootstrap from 'bootstrap-vue';
    import TrackApis from '@/apis/_apiTracks'
    export default {
        name: 'DemoTrackSelector',
        components: { /*Modal,*/ WaitingBlock },
        computed: {
            Translations: () => Translations,
            trackUids() {
                return this.tracks.map(track => track.uid)
            },
        },
        mounted() {
            this.search();
        },
        props: {
            value: { type: Object, default: () => { return {} } },
            multiselect: { required: false, default: true },
            stationUid: String
        },
        data() {
            return {
                modalState: {
                    hasSearchProcessed: false,
                    isLoadingTracks: false,
                    delayedSearch: null
                },
                selected: this.value || {},
                searchResult: null,
                searchData: {
                    searchTerm: "",
                    pageSize: 50,
                    page: 1,
                }
            };
        },
        methods: {
            normalizeSearchTerm(str) {
                return (str || "").normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
            },
            isSelected(id) {
                return this.selected.id === id
            },
            open() {
                this.$refs.modal.show()
                this.$refs.inputSearch.focus()
            },
            close() {
                this.$refs.modal.hide()
            },
            reset() {
                this.modalState.hasSearchProcessed = true;
                this.searchData.searchTerm = "";
            },
            confirmModal() {
                this.$emit('input', { ...this.selected })
                this.reset()
                this.close()
            },
            cancelModal() {
                this.reset()
                this.$emit("onHidden")
                this.close()
            },
            // ------------------------------------------------------
            /* Start : Common Behaviour */
            // ------------------------------------------------------

            searchDelay(delay) {
                if (this.delayedSearch != null) clearTimeout(this.delayedSearch);
                this.delayedSearch = setTimeout(this.search, delay || 150);
            },
            search() {
                this.modalState.isLoadingTracks = true
                // console.log('search', this.searchData.searchTerm)
                TrackApis.getDemoTracks(this.stationUid, this.searchData.searchTerm)
                    .then(this.searchEnd,this.searchError)
                    .then(this.searchCompleted)

            },
            searchEnd(response) {
                console.log(response);
                var demos = (response.data.dataItem || {}).items || [];
                if (demos.length > 0) {
                    this.searchResult = response.data.dataItem.items[0];
                }
            },
            searchError(data) {
                this.searchResult = data;
            },
            searchCompleted(response) {
                this.modalState.isLoadingTracks = false;
                this.modalState.hasSearchProcessed = true;
            },

            // ------------------------------------------------------
            /* End : Common Behaviour */
            // ------------------------------------------------------

            toggleLabel(label) {
                if (this.selected && label.id == this.selected.id) {
                    this.selected = {};
                }
                else {
                    this.selected = label;
                }
            },
        }
    }
</script>
